<div class="order-book-diagrammatic">
	<div class="info">
		<span
			class="title bid"
			[tuiSkeleton]="isLoading"
			>{{ 'orderBook.bid' | translate }}</span
		>
		<span
			class="value"
			[tuiSkeleton]="isLoading"
			[appAnimatedNumber]="orderBook?.bid ?? 0 | price"
		></span>
		<span
			class="count"
			[tuiSkeleton]="isLoading"
			[appAnimatedNumber]="'x' + orderBook?.bidSize"
		></span>
	</div>

	<div class="lines">
		<div
			class="line bid"
			[tuiSkeleton]="isLoading"
			[style.height]="percentBidSize + '%'"
		></div>
		<div
			class="line ask"
			[tuiSkeleton]="isLoading"
			[style.height]="percentAskSize + '%'"
		></div>
	</div>

	<div class="info">
		<span
			class="title ask"
			[tuiSkeleton]="isLoading"
			>{{ 'orderBook.ask' | translate }}</span
		>
		<span
			class="value"
			[tuiSkeleton]="isLoading"
			[appAnimatedNumber]="orderBook?.ask ?? 0 | price"
		></span>
		<span
			class="count"
			[tuiSkeleton]="isLoading"
			[appAnimatedNumber]="'x' + orderBook?.askSize"
		></span>
	</div>
</div>
